/**
 * @generated SignedSource<<1ae62503081f5f564f4d6cfd4d0ddf83>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type questionLayout_viewer$data = {
  readonly singleQuestion: {
    readonly answerCount: number | null;
    readonly relatedQuestionItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly item: {
            readonly photos: ReadonlyArray<{
              readonly masterOrZoomPath: string | null;
            } | null> | null;
            readonly title: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly title: string | null;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"Answers_question" | "RelatedQuestionItems_question" | "RelatedQuestions_question" | "SellerItems_question">;
  } | null;
  readonly " $fragmentType": "questionLayout_viewer";
};
export type questionLayout_viewer$key = {
  readonly " $data"?: questionLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"questionLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "urlLabel"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "questionLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabel",
          "variableName": "urlLabel"
        }
      ],
      "concreteType": "QuestionType",
      "kind": "LinkedField",
      "name": "singleQuestion",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answerCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RelatedQuestionItemsConnection",
          "kind": "LinkedField",
          "name": "relatedQuestionItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RelatedQuestionItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemSearchResult",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Item",
                      "kind": "LinkedField",
                      "name": "item",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "limit",
                              "value": 1
                            }
                          ],
                          "concreteType": "ItemPhoto",
                          "kind": "LinkedField",
                          "name": "photos",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "masterOrZoomPath",
                              "storageKey": null
                            }
                          ],
                          "storageKey": "photos(limit:1)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Answers_question"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RelatedQuestionItems_question"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RelatedQuestions_question"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SellerItems_question"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "65abd4eae726ad93f479865025e70a02";

export default node;
